module.exports = __webpack_public_path__ + "img/cross sell Up Cultura.faba3ae1.jpeg";